import React, {useEffect} from 'react';
import { assetPath } from '../../../utils/web-helper';
import { SubjectLoadthroughImages } from '../../../constant-data/splashverse-onboarding';
import * as S from './style';
import { useDispatch } from 'react-redux'
import { setSelectedSubject, setBackButtonNotLoading } from '../../../stores/splashverse-onboarding/actions';

const SubjectLoadthrough = ({selectedSubject, goToNextHandler, skipPOQ, isPreKindergarten}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let timer1 = setTimeout(() => {
      dispatch(setBackButtonNotLoading());
      dispatch(setSelectedSubject(selectedSubject));
      let opt = {
        skipPOQ,
        selectedSubject,
        isPreKindergarten
      };
      goToNextHandler('subject_selection', opt);
    }, 2000);
    return () => {
      clearTimeout(timer1);
    }
  });
  return (
    <>
      {SubjectLoadthroughImages[selectedSubject].length > 0 ?
        <S.GradesContainer>
          <S.LoadthroughContainer selectedSubject={selectedSubject}>
            { SubjectLoadthroughImages[selectedSubject].map(img => <img src={assetPath(img)}/>) }
          </S.LoadthroughContainer>
        </S.GradesContainer> : null
      }
    </>
  )
}

export default SubjectLoadthrough;